import React from "react"
import "../App.css"

export default function Stop(props: { name: string }) {
  return <strong>{props.name}</strong>
}
